var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            sm: "12",
            md: "4"
          }
        },
        [_c("email-opt")],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            sm: "12",
            md: "4"
          }
        },
        [_c("access-to-records")],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            sm: "12",
            md: "4"
          }
        },
        [_c("request-profile-remove")],
        1
      ),
      _c(
        "v-col",
        {
          attrs: {
            cols: "12",
            sm: "12"
          }
        },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  attrs: {
                    cols: "12",
                    sm: "12"
                  }
                },
                [_c("my-data-request")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }